import { Skeleton } from "@/components/ui/skeleton";

function ProfileInfoSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="h-7 w-48" />

      <div className="rounded-2xl bg-card px-4 py-6 shadow-xl">
        <div className="flex flex-col gap-4 md:grid md:grid-cols-3">
          {Array.from({ length: 5 }).map((_, index) => (
            <div key={index} className="flex flex-col gap-2">
              <Skeleton className="h-4 w-24" />
              <Skeleton className="h-14 w-full rounded-2xl" />
            </div>
          ))}
        </div>

        <div className="mt-4 flex justify-end">
          <Skeleton className="h-10 w-full rounded-md md:w-40" />
        </div>
      </div>
    </div>
  );
}

function PasswordSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="h-7 w-28" />

      <div className="flex flex-col items-center justify-between gap-4 rounded-2xl bg-card px-4 py-6 shadow-xl md:flex-row">
        <Skeleton className="h-5 w-48" />
        <Skeleton className="h-10 w-full rounded-md md:w-40" />
      </div>
    </div>
  );
}

function EInvoiceSkeleton() {
  return (
    <div className="flex flex-col gap-2">
      <Skeleton className="h-7 w-56" />

      <div className="rounded-2xl bg-card px-4 py-6 shadow-xl">
        <div className="flex flex-col gap-4 md:grid md:grid-cols-3">
          {Array.from({ length: 15 }).map((_, index) => (
            <div
              key={index}
              className={
                index === 9 || index === 10 || index === 11
                  ? "md:col-span-3"
                  : ""
              }
            >
              <div className="flex flex-col gap-2">
                <Skeleton className="h-4 w-24" />
                <Skeleton className="h-14 w-full rounded-2xl" />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-4 flex justify-end">
          <Skeleton className="h-10 w-full rounded-md md:w-40" />
        </div>
      </div>
    </div>
  );
}

export function ProfileSkeleton() {
  return (
    <div className="flex flex-col gap-6">
      <ProfileInfoSkeleton />
      <PasswordSkeleton />
      <EInvoiceSkeleton />
    </div>
  );
}